/**
 * Compares two elements and returns a number indicating their order
 *
 * The comparison will not execute if the elements are of different types (and therefore not comparable)
 *
 * @param {any} a The first element for comparison
 * @param {any} b The second element for comparison
 * @returns {number} -1 if `a` comes before `b`; 1 if `a` comes after `b`; 0 if `a` and `b` are considered equal
 */
export default function compareTwoValues(a, b) {
  if (typeof a !== typeof b) {
    console.warn('-- Comparison aborted: types do not match');
    return 0; // leave the values as-is
  }

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}
